import { Box, Button, TextField } from "@mui/material"
import Drawer from "@mui/material/Drawer"
import { Close } from "@mui/icons-material"
import { useCallback, useEffect, useRef } from "react"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import { useObservable } from "src/framework/store/storeUtil"
import { LoginStore } from "src/framework/store/LoginStore"
import { FilterProps } from ".."

interface FilterDrawerProps {
  isAdm: boolean;
  isOpened: boolean;
  close: () => void;
  filters: FilterProps
  setFilters: (filters: FilterProps) => void
  handleSearch: () => void
}

const INITIAL_FILTERS_STATE = {
  search_id: "",
  search_nome: "",
}

const FilterDrawer = ({ isOpened, close, filters, setFilters, handleSearch, isAdm }: FilterDrawerProps) => {
  const cbRef = useRef<any>(null)
   const permissoes:string[] = useObservable(LoginStore.permissoes) || [];

  const eventSubmit = useCallback((e: any)=>{
    const cb = (e: any) => cbRef.current(e)
    if (e.keyCode === 13) cb(e)
  },[])

  useEffect(()=>{
    if (isOpened) {
      window.addEventListener('keypress', eventSubmit, true)
    } else {
      window.removeEventListener('keypress', eventSubmit, true)
    }
  },[eventSubmit, isOpened])

  useEffect(()=>{
    cbRef.current = handleSearch
  },[handleSearch]) 

  const maskNumber = (value: string)=>{
    let _value = ""
    if (value){
      _value = value.replace(/[^0-9]/g,"")
    }    
    return _value;
  }

  return (
    <Drawer PaperProps={{ style: { width: 400 }}} anchor="right" open={isOpened} onClose={close}>
        <Box paddingLeft={'10px'} >
          <Button
              variant="text"
              color="primary"
              startIcon={<Close />}
              style={{marginTop: 10, marginBottom: 50}}
              onClick={close}
              >
              Fechar
          </Button>
        </Box>
        <Box flex={1} padding={2} alignItems='flex-start' display='flex' flexDirection={'column'}>
        {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE, permissoes) &&(<TextField
            fullWidth
            style={{marginTop: 20}}
            label="Busca por código"
            variant="outlined"
            value={filters.search_id}
            onChange={e => {
              const localFilters = {...filters}
              const _id = maskNumber(e.target.value);
              localFilters.search_id = _id
              setFilters(localFilters)
            }} 
        />)}
        <TextField
            fullWidth
            style={{marginTop: 20}}
            label="Busca por palavra-chave"
            variant="outlined"
            value={filters.search_nome}
            onChange={e => {
                const localFilters = {...filters}
                localFilters.search_nome = e.target.value
                setFilters(localFilters)
            }} 
        />
          
        </Box>

        <Box height='75px' p={2} marginTop={'10px'} width={'100%'} display='flex' justifyContent={'flex-end'}>
          <Button onClick={() => setFilters(INITIAL_FILTERS_STATE)} style={{marginRight: '10px'}}  color="primary" variant="outlined">Limpar filtros</Button>
          <Button onClick={handleSearch} color="primary" variant="contained">Buscar</Button>
        </Box>

      </Drawer>
  )
}

export { FilterDrawer }
